import React from 'react';
import { Link } from 'react-router-dom';

// Kart bilgilerini array olarak tanımla
const cards = [
  {
    title: 'Gelişimli Olmak',
    image: '/images2/gelisimliOlmak.png',
    url: '/gelisimli-olmak',
  },
  {
    title: 'Gelişim’de Yabancı Dil',
    image: '/images2/gelisimdeYabanciDil.png',
    url: '/yabanci-dil',
  },
  {
    title: 'Gelişim’de Rehberlik',
    image: '/images2/gelisimdeRehberlik.png',
    url: '/rehberlik',
  },
  {
    title: 'Gelişim’de Spor',
    image: '/images2/gelisimdeSpor.png',
    url: '/spor',
  },
  {
    title: 'Gelişim’de Sanat',
    image: '/images2/gelisimdeSanat.png',
    url: '/sanat',
  },
  {
    title: 'Gelişim’de Teknoloji',
    image: '/images2/gelisimdeTeknoloji.png',
    url: '/teknoloji',
  },
];

const HomeCards = () => {
  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {cards.map((card, index) => (
          <Link
            to={card.url}
            key={index}
            className="group transform transition duration-300 hover:scale-105"
            >
            <div className="rounded-xl overflow-hidden shadow-lg bg-white">
                <img
                src={card.image}
                alt={card.title}
                className="w-full h-48 object-cover transition-transform duration-300"
                />
                <div className="p-4 bg-[#a03838]">
                    <h3 className="text-center text-lg font-semibold text-white">
                        {card.title}
                    </h3>
                </div>
            </div>
            </Link>

        ))}
      </div>
      <div className="max-w-5xl mx-auto text-center mt-8 px-4">
        <p className="text-lg md:text-xl text-black-700 font-playfair font-semibold">
            Gelişim Koleji’nde her alanda yetkin bireyler yetiştirmek için yabancı dilden spora,
            sanattan teknolojiye kadar çok yönlü bir gelişim ortamı sunuyoruz.
        </p>
      </div>
    </section>
  );
};

export default HomeCards;
